/**
 * Analytics utility for Plausible tracking
 * Centralized event tracking with error handling and dev mode support
 */

// Check if we're in development mode
const isDevelopment = process.env.NODE_ENV === 'development';
const isAnalyticsEnabled = process.env.REACT_APP_ENABLE_ANALYTICS === 'true';
const domain = process.env.REACT_APP_PLAUSIBLE_DOMAIN;

/**
 * Track an event with Plausible Analytics
 * @param {string} eventName - Name of the event to track
 * @param {object} properties - Event properties (optional)
 * @param {object} options - Additional options (optional)
 */
export const trackEvent = (eventName, properties = {}, options = {}) => {
  try {
    // Log to console in development
    if (isDevelopment) {
      console.log('📊 Analytics Event:', eventName, properties);
    }

    // Only track if Plausible is available
    if (typeof window !== 'undefined' && window.plausible) {
      const eventData = {
        ...options,
        ...(Object.keys(properties).length > 0 && { props: properties })
      };
      
      window.plausible(eventName, eventData);
    } else if (isDevelopment) {
      console.warn('Plausible not available - event not tracked');
    }
  } catch (error) {
    if (isDevelopment) {
      console.error('Analytics tracking error:', error);
    }
  }
};

/**
 * Track page views (usually handled automatically by Plausible)
 * Use this for SPA route changes if needed
 */
export const trackPageView = (url, options = {}) => {
  trackEvent('pageview', {}, { u: url, ...options });
};
